import React, { useState, useEffect } from 'react';
import { Badge } from './ui/badge';
import ProjectCarousel from './ProjectCarousel';
import { useTranslation } from 'react-i18next';

const CATEGORIES = ['Béton Imprimé', 'Béton Désactivé', 'Béton Lissé', 'Béton Ciré'];

const FeaturedProjects = () => {
  const { t } = useTranslation();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    fetch('/images/projects/projects_metadata.json')
      .then(r => r.json())
      .then(data => {
        const built = CATEGORIES.map(cat => {
          const catImages = data
            .filter(img => img.category === cat)
            .slice(0, 5)
            .map(img => `/images/projects/${img.webp}`);
          return {
            title: cat,
            category: cat,
            location: 'Vaucluse & PACA',
            images: catImages,
          };
        }).filter(g => g.images.length > 0);
        setGroups(built);
      })
      .catch(console.error);
  }, []);

  if (groups.length < 2) return null;

  return (
    <section id="realisations" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#141823]">
      <div className="container mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-3 gap-8 items-center">
          <div className="lg:col-span-1">
            <ProjectCarousel group={groups[0]} />
          </div>
          <div className="lg:col-span-1 text-center px-4">
            <Badge className="mb-4 bg-[#4FB7A8] text-white">{t('home.testimonialsBadge')}</Badge>
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4 leading-tight">
              {t('featuredProjects.title')}
            </h2>
            <p className="text-lg text-slate-300">
              {t('featuredProjects.subtitle')}
            </p>
          </div>
          <div className="lg:col-span-1">
            <ProjectCarousel group={groups[1]} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
